export default state => state.category.isCurated;
